// Projector (Entertainment): formats and their ladder of proof, tests,
// evenings and the register, broadcasters, export markets, the weekly,
// printable deliverables; and a brand's 90-day programme.
export default {
  citation: '“{texte}”',
  fourchette: '{bas}% ~ {haut}%',
  cible: {
    '4+': 'Ages 4+',
    '4-14': 'Ages 4-14',
    '15-34': 'Ages 15-34',
    '25-49': 'Ages 25-49',
    'FRDA-50': 'FRDA-50',
    '50+': 'Ages 50+',
  },
  // A study's age brackets (October 15, 2026).
  tranche: {
    de: 'Ages {lo}-{hi}',
    etPlus: 'Ages {lo}+',
    ans: '{n} years old',
    aucune: 'No bracket: the study takes every age its audiences have.',
    ajouter: 'Add an age bracket',
    retirer: 'Remove {tranche}',
    min: 'Minimum age, bracket {n}',
    max: 'Maximum age, bracket {n}',
    max4: '{max} brackets at most.',
  },
  dimensionPublic: {
    pyramide: 'the age mix',
    femmes: 'the share of women',
    diplome: 'education levels',
    urbanite: 'where people live',
    origine: 'origin',
    religion: 'religion',
  },
  etat: {
    preparation: 'Protocol being written',
    protocole_en_echec: 'Protocol failed',
    a_relire: 'To review before launch',
    lancement: 'Freezing the population',
    en_cours: 'The panel is answering',
    rendu: 'Results ready',
    partiel: 'Partial results',
    echec: 'Test failed',
  },
  etape: {
    brief: {
      titre: 'Brief',
      support: 'the category, the broadcaster, the slot, the target, the audience goal',
      stimulus: 'the settings: channel, slot, competition',
      sortie: 'the audiences to survey for this broadcaster',
    },
    format_papier: {
      titre: 'Paper format',
      support: 'the title, the logline, the promise',
      stimulus: 'a short text',
      sortie: 'appetite to watch by target, and the indifferent',
    },
    dossier: {
      titre: 'Treatment',
      support: 'the statement of intent, the mechanics, the tone',
      stimulus: 'a long text, in variants',
      sortie: 'the winning variant, target by target',
    },
    visuel: {
      titre: 'Visuals',
      support: 'the deck, the moodboard, the set, the teasers',
      stimulus: 'images, videos',
      sortie: 'buy-in to the world',
    },
    casting: {
      titre: 'Casting',
      support: 'the host, the coaches, the contestants',
      stimulus: 'names, photos',
      sortie: 'the talent effect by target',
    },
    ab: {
      titre: 'A/B Testing',
      support: 'variants, visuals, talent',
      stimulus: 'texts, images, videos, names',
      sortie: 'the winning version, target by target',
    },
    pilote: {
      titre: 'Episode',
      support: 'an episode, the pilot, the demo',
      stimulus: 'a video',
      sortie: 'retention sequence by sequence, the high and low points, the overall feeling',
    },
    lancement: {
      titre: 'Broadcast',
      support: 'the competing schedule, or the release on a platform',
      stimulus: 'a simulated evening',
      sortie: 'the projected audience share, then checked against the ratings',
    },
    export: {
      titre: 'Export',
      support: 'the format, country by country',
      stimulus: 'the same format, read elsewhere',
      sortie: 'stability from one country to another',
    },
  },
  groupe: {
    programme: 'The programme audience',
    france: 'France',
    ville: 'Major cities',
    chaine: 'Channel audiences',
    plateforme: 'Platform audiences',
    jeunes: 'Young audiences',
    pays: 'Export markets',
    thematique: 'Niche audiences',
    politique: 'Political audiences',
  },
  provenance: {
    mesure: 'Measurement',
    simulation: 'Simulation',
    observation: 'Listening',
  },
  profil: {
    femme: 'woman',
    homme: 'man',
    age: '{age}',
  },
  erreur: {
    grilles: 'Schedules could not be read',
  },
  commun: {
    chargement: 'Loading…',
    fermer: 'Close',
    fermerMin: 'close',
    retirer: 'Remove',
    annuler: 'Cancel',
    refuse: 'Refused',
    valider: 'Approve',
    rejeter: 'Reject',
    ecarter: 'Discard',
    enregistrer: 'Save',
    archiver: 'Archive',
    cible: 'Target',
    leRegarderaient: 'Would watch',
    scenarios: 'Scenarios',
    ensemble: 'Overall',
    vosCibles: 'Your targets',
    pays: 'Country',
    audienceAuLancement: 'Launch audience',
    sur: 'of {sur}',
    entre: ', between {a} and {b}',
    devant: ', ahead of {a}',
    derriere: ', behind {a}',
    scenariosCourts: '{bas} ~ {haut}',
    format: 'Format',
    chaineAnnee: 'Channel, year',
    simulee: 'Simulated',
    projetee: 'Projected',
    partDAudience: 'Audience share',
    mesuree: 'Measured',
    ecart: 'Gap',
    telespectateurs: 'Viewers',
    millionsScenarios: '{valeur}{bornes}',
    ceQueLePanelEnDit: 'What the panel says',
    aValider: '{nb} to approve',
    programme: 'Programme',
    reelle: 'Actual',
    placeholderPda: 'Share %',
    placeholderTelespectateurs: 'viewers',
    releveEnCours: 'Fetching',
    raisonInconnue: 'unknown reason',
    chaine: 'Channel',
    genre: 'Genre',
    source: 'Source',
    valideMin: 'approved',
    quiLaRegarde: 'Who watches it',
    ceDontSonPublicParle: 'What its audience talks about',
    formatsTestesPourElle: 'Formats tested for it',
  },
  panel: {
    titre: 'The panel surveyed',
    bloc: {
      age: 'Age',
      genre: 'Gender',
      csp: 'Occupation',
      diplome: 'Education',
      foyer: 'Household',
      lieu: 'Where they live',
      publics: 'Audiences',
    },
  },
  ecoute: {
    enLigne: 'Online',
    ecouter: 'Listen online',
    pasEncore: 'Not listened to yet.',
    enCours: 'Listening in progress.',
    polarite: '{favorable} favourable, {neutre} neutral, {defavorable} unfavourable',
    favorables: 'favourable',
    neutres: 'neutral',
    defavorables: 'unfavourable',
    voirPlus: 'See more',
    rien: 'Nothing to show online yet.',
    reecouter: 'Listen again',
    panneau: 'What “{titre}” sparks online',
    origine: 'people talking about “{titre}” online',
  },
  corpus: {
    erreur: {
      illisibles: 'Documents could not be read',
      depot: 'Upload refused',
    },
    titreParDefaut: 'Note',
    cetteComposition: 'this breakdown',
    avisPublic: 'The programme audience is now drawn from this figure for {dimension}; everything else follows France.',
    sur: 'out of {max}',
    titre: 'The format’s documents',
    natureDuDocument: 'Document type',
    nature: {
      brief: 'Brief, specifications',
      presentation: 'Presentation, deck',
      bible: 'Bible, format concept',
      script: 'Script, running order',
      etude: 'Study',
      sondage: 'Poll',
      donnees: 'Data, ratings',
      presse: 'Press, press review',
      veille: 'Market watch, competition',
      compte_rendu: 'Meeting minutes',
      contrat: 'Contract, tender',
      note: 'Note',
      media: 'Visual',
    },
    deposerFichiers: 'Upload files',
    collerTexte: 'Paste text',
    sonTitre: 'Title',
    placeholderTexte: 'What you know about this format and its audience: a note, a study extract, ratings…',
    ajouter: 'Add to the corpus',
    envoi: 'Uploading…',
    toutLeCompte: 'whole account',
    chiffres: '{n} figures | {n} figure | {n} figures',
    enLecture: 'Reading',
    illisible: 'Unreadable',
    lu: 'Read',
    misDeCote: 'Set aside',
    mettreDeCote: 'Set aside',
    resservir: 'Use it again',
    retirer: 'Remove from the corpus',
    chiffresLus: 'Figures found',
    compositionDuPublic: 'Audience breakdown: {dimension}',
    valide: 'Approved',
    rejete: 'Rejected',
    tirerDessus: 'The figure is right, draw on it',
    aucun: 'No documents yet.',
  },
  creation: {
    variante: 'Variant {lettre}',
    visuel: 'Visual {n}',
    pilote: 'Episode of “{titre}”',
    erreur: {
      envoi: 'Upload failed',
      test: 'Test refused',
    },
    probleme: {
      public: 'Choose at least one audience.',
      comparable: 'Each comparable needs a name and a few lines of description.',
      variante: 'Each variant needs at least a few lines of text.',
      visuel: 'Each visual needs its image or video.',
      talent: 'Each talent needs a name.',
      video: 'Upload the video or give its YouTube link.',
      grille: 'Fetch the evening’s schedule first.',
      programme: 'Choose the programme.',
      dateSortie: 'Fill in the release date in the brief (first broadcast).',
      pays: 'Choose at least one country.',
    },
    tester: 'Test: {etape}',
    ceQueLePanelVerra: 'What the panel will see',
    promesse: 'The promise: {texte}',
    placeholder: {
      comparable: 'Name of the comparable (for you only)',
      pdaReelle: 'Actual share %',
      description: 'Its description, without its title: the panel reads it blind',
      noteIntention: 'The statement of intent, the mechanics, the tone of this version',
      talent: 'Name of the talent (host, coach, contestant)',
      visuel: 'Name of the visual',
      role: 'What they would do in the programme (optional)',
      legende: 'A caption, if the visual has one (optional)',
      adresse: 'or its URL https://',
      youtube: 'or a YouTube link https://',
    },
    ajouterComparable: 'Add a comparable',
    ajouterVariante: 'Add a variant',
    deposerPhoto: 'Upload a photo',
    deposerImage: 'Upload the image',
    ajouterTalent: 'Add a talent',
    ajouterVisuel: 'Add a visual',
    deposerVideo: 'Upload the video',
    sortie: '“{titre}” is released on {plateforme} on {jour}.',
    sortieSansDate: '“{titre}” is released on {plateforme}.',
    sortieMesure: 'who would watch it in its first week, target by target',
    ab: {
      compare: 'What we compare',
      dossier: 'Texts',
      visuel: 'Visuals or videos',
      casting: 'Talent',
      mode: 'How the panel sees them',
      separe: 'Separately',
      separeAide: 'Each twin sees a single version and says how much they want to watch; the gap reads from one version to the next. Closest to real life.',
      coteACote: 'Side by side',
      coteACoteAide: 'Each twin sees every version, then picks the one that makes them most want to watch, or none. More sensitive to small gaps, which it also magnifies.',
      deuxAuMoins: 'Side by side needs at least two versions.',
    },
    sortieQuestion: 'The twins say whether they would watch it, and when: on release, within the week, later or not at all.',
    aucuneGrille: 'No schedule fetched.',
    grilleVide: 'The TV guide does not cover the coming days yet: it is read every night.',
    soireesAVenir: 'The TV guide, coming days',
    soireesRelevees: 'Evenings already fetched',
    soireesPassees: 'Past evenings, replayed blind',
    contexte: {
      annonce: 'What the programme announces that evening',
      annoncePlaceholder: 'For example: no elimination this Saturday; surprise guests.',
      case: 'Add what was said online about the programme the week before',
      calcul: 'Reading the week before on social media…',
      erreur: 'What was said online could not be read: the test is prepared without it.',
      apercu: 'What the panel will read about the programme, on top of the TV guide:',
      rien: 'Nothing notable online the week before: the programme is shown without it.',
      partiel: 'Social networks only keep seven days: part of the week before could not be counted.',
      attente: 'What was said online is still being read.',
    },
    releverGrille: 'Fetch an evening’s schedule',
    nProgrammes: '{nb} programmes',
    programmeProjete: 'The programme whose audience we project:',
    quiRepond: 'Who answers',
    jusquA: 'Up to {max} audiences',
    combienDeJumeaux: 'How many twins per version',
    jumeauxParPublic: 'How many twins per audience',
    totalVersion: '{publics} audiences × {par} = {total} twins per version | {publics} audience × {par} = {total} twins per version | {publics} audiences × {par} = {total} twins per version',
    plafond: ' (a version’s ceiling)',
    cibles: {
      titre: 'Target',
      aide: 'Twins are drawn within these targets, and the test reads on them.',
      aucune: 'No target: the test reads on the whole panel.',
    },
    publics: 'Audiences',
    // The creation window, one step at a time (October 15, 2026).
    pas: {
      etapes: 'Steps',
      montre: 'What we show',
      soiree: 'The evening',
      appuis: 'Build on',
      publics: 'Who answers',
      ages: 'Ages',
      n: 'Step {n} of {total}',
      suivant: 'Next',
      precedent: 'Back',
    },
    ages: {
      titre: 'Ages (optional)',
      aide: 'Twins are drawn within these ages, and the study reads bracket by bracket.',
      frda: 'Women under 50 who make the household purchases',
      orphelines: '{ages}: none of the chosen audiences covers these ages.',
      couvrir: 'Add audiences for these ages',
    },
    appuis: {
      titre: 'Build on',
      aideSortie: 'Twins see the show the way these studies made it win: the tested pitch, the chosen version. The results chain them together.',
      aideSoiree: 'The programme appears in the evening’s TV guide the way these studies made it win: the chosen version, the talent, the key art. The results chain them together.',
      aucune: 'None',
      vide: 'No study with results',
      bloc: {
        format_papier: 'Paper format',
        ab: 'A/B Testing',
        pilote: 'Episode',
      },
      envie: '{pct} want to watch',
      version: 'Chosen version',
      gagnante: 'winner',
      jusquAuBout: '{pct} watch to the end',
      chargement: 'Loading…',
      ajouter: 'Add',
      changer: 'Change',
      retirer: 'Remove',
      aucuneChoisie: 'No study chosen',
      choisir: 'Choose a study: {bloc}',
      lEmporte: '“{version}” wins, {pct}',
    },
    nJumeaux: '{nb} twins',
    preparer: 'Prepare the test',
  },
  donne: {
    titre: 'What the panel was given',
    backtest: 'replayed blind',
    annonce: 'Announcement: “{texte}”',
    enLigne: 'What was said online the week before',
    seul: 'The TV guide only, no announcement or context',
    habitudes: 'Channel habits drawn from audience shares',
    appui: { format_papier: 'The paper format', ab: 'The A/B test', pilote: 'The episode' },
  },
  test: {
    pilote: {
      debut: 'Start',
      fin: 'End',
      titre: 'Who is still watching',
      tenue: 'Holding up from region to region: to the end',
      jusquAuBout: '{cible}: {pct} to the end',
    },
    erreur: {
      illisible: 'Test could not be read',
      action: 'Action refused',
    },
    export: {
      verdict: {
        stable: 'stable: it travels as is',
        variable: 'variable: it adapts',
        fragile: 'fragile: it needs remaking',
        illisible: 'unreadable',
      },
      avecEcart: 'The format is {verdict} (largest gap with France: {ecart} points).',
      sansEcart: 'The format is {verdict}.',
    },
    etape: {
      format_papier: 'Paper format',
      dossier: 'Treatment',
      visuel: 'Visuals',
      casting: 'Casting',
      pilote: 'Episode',
      lancement: 'Simulated evening',
      export: 'Export',
      etalonnage: 'Country benchmarking',
    },
    grilleDeLaSoiree: 'The evening’s schedule',
    versions: '{n} versions | {n} version | {n} versions',
    jumeauxChacune: '{nb} twins each',
    panelFige: 'Panel frozen on {jour}',
    aLAveugle: ', blind',
    reference: 'reference',
    ceQueLePanelVoit: 'What the panel sees, version by version',
    tirEnEchec: 'Run failed',
    protocoleSEcrit: 'The protocol is being written.',
    protocoleEchoue: 'Writing the protocol failed.',
    reecrireProtocole: 'Rewrite the protocol',
    ceQueLePanelLira: 'What the panel will read',
    termesFiges: 'Fixed terms',
    definition: '{terme}: {sens}',
    soireePassee: 'This evening has already aired: it is replayed as a blind backtest.',
    taille: '{bras} × {effectif} twins',
    environ: 'about {duree}',
    dureeMinutes: '{n} minutes',
    dureeHeures: '{h} hr {m} min',
    dureeHeuresRondes: '{h} hr',
    lancerBacktest: 'Run the backtest',
    lancerTest: 'Run the test',
    lePanelPart: 'The panel is starting.',
    lePanelRepond: 'The panel is answering · about {duree} in all.',
    lePanelRepondReste: 'The panel is answering · about {duree} to go.',
    reponsesRecues: '{pct} of answers received',
    versionSansReponse: 'A version did not respond.',
    relancer: 'Run again',
    redresse: 'Weighted to France, individuals 4+:',
    redressement: '{bande} {panel} of the panel, {france} of France;',
    envieDeRegarder: 'Appetite to watch',
    leRegarderaientFourchette: 'would watch it ({fourchette})',
    surVosCibles: 'among your targets: {cibles}',
    indifferentsEgal: 'indifferent (“I don’t mind”)',
    indifferents: 'Indifferent',
    reponses: 'Answers',
    dansSaClasse: 'In its class',
    surLusAveugle: 'of {sur}, read blind by the same panel',
    leFormat: 'The format',
    pdaReelle: 'Actual share {pda}',
    projectionParLaClasse: 'Projection from the class: {pda} audience share{bornes}, based on {points} comparables with known ratings.',
    comparaison: {
      casting: 'Each talent’s effect',
      export: 'The format, from one country to another',
      visuel: 'Buy-in to each world',
      dossier: 'The winning variant',
    },
    lEmporte: '{nom} wins.',
    devanceDePeu: '{nom} is narrowly ahead: by less than five points.',
    passeport: {
      titre: 'The passport: the format as read in each country, among its own formats',
      parmiLesFormats: 'Among the country’s formats',
      etalonner: 'Benchmark {pays}',
    },
    etalons: {
      titre: 'Benchmark formats, as read by the country’s population',
    },
    seconde: {
      titre: 'Part 2, {creneau}',
    },
    soiree: {
      titreSimulee: 'Simulated audience share · {programme}',
      titreProjetee: 'Projected audience share · {programme}',
      panelBrut: 'Raw panel',
      dOuVient: 'Where the figure comes from',
      mesures: 'measured: {valeur}',
      nosJumeaux: 'our twins, 100%',
      habitude: 'measured habit, 100%',
      etLeGenre: ', and the genre',
      melange: 'twins {isos}%, habit {mesure}%',
      corrigee: 'Corrected by calibration v{version}, learnt from evenings already checked against reality: “where the figure comes from” shows what it takes from the twins and what it takes from the channel’s usual share.',
      essaiDu: 'Dry run, {moment}',
      projectionDu: 'Projection, {moment}',
      enregistrerEssai: 'Record a dry run',
      enregistrerBacktest: 'Record the backtest',
      enregistrerProjection: 'Record the projection',
      enDirect: 'The live evening · overall',
      ouVaLaSoiree: 'Where the evening goes · all screens',
    },
    ecran: {
      direct: 'Live TV',
      replay: 'Catch-up, on demand',
      plateforme: 'Streaming platforms',
      reseaux: 'YouTube, social media',
      aucun: 'No screen',
    },
    personas: {
      titre: 'The panel’s personas',
      origine: 'this test’s panel',
      q1: 'Why would you watch it?',
      q2: 'What’s holding you back?',
      q3: 'Which version spoke to you most, and why?',
    },
  },
  livrable: {
    titre: {
      dossier: 'Audience report',
      casting: 'Casting note',
      passeport: 'Format passport',
      diffuseur: 'Broadcaster profile',
      enveloppe: 'The projection',
      sonar: 'Study note',
    },
    livrable: 'Deliverable',
    illisible: 'Deliverable could not be read',
    retour: 'Back',
    imprimer: 'Print',
    confidentiel: 'Confidential',
    dossier: {
      envie: '{pct} of the panel would watch it{fourchette}; {indifferents} are indifferent.',
      classe: 'In its class: {rang} comparable formats read blind.',
      classeAvecProjection: 'In its class: {rang} comparable formats read blind; projection from the class: {pda} audience share{bornes}.',
      adhesion: 'Buy-in to the world',
      versionQuiGagne: 'The winning version',
      devanceDePeu: '{nom} is narrowly ahead.',
    },
    nomCitation: '{nom}: “{texte}”',
    casting: {
      explication: 'Each talent is read against the same programme with no talent announced: the gap is their effect.',
      talent: 'Talent',
    },
    passeport: {
      stabilite: 'Stability from one country to another',
      ecartFrance: 'Gap with France',
      parmiSesFormats: 'In each country, among its own formats',
      place: 'Rank among the country’s formats',
    },
    scenarios: '({bas} ~ {haut})',
    diffuseur: {
      public: 'Audience',
      part: 'Share',
      ages: 'Ages',
      pda: 'Its audience share (Médiamat, individuals 4+)',
      observation: 'Observation · public conversations',
      ceQuiMonte: 'What’s rising:',
    },
    enveloppe: {
      enregistreeLe: '{quoi}, recorded on {moment}',
      partProjetee: 'Projected audience share',
      audiencePubliee: 'Published ratings',
      aVenir: 'to come',
      note: 'Audience share among those watching live TV{calibration}. The evening’s schedule: {grille}.',
      calibrationV: ', calibration v{version}',
      empreinte: 'SHA-256 fingerprint of the envelope’s canonical content:',
      temoins: 'Submitted to the OpenTimestamps witnesses: {liste}. The proof (.ots) can be checked without Orion, against the fingerprint, once anchored in Bitcoin.',
      aucun: 'none',
    },
    pied: {
      test: 'A panel of twins built on each population’s public statistics (age, gender, education, outlook), surveyed {quand}{population}.',
      leMoment: 'on {moment}',
      populationFigee: ' using a population frozen on {jour} (fingerprint {empreinte})',
      sonar: 'A panel of twins built on each population’s public statistics (age, gender, education, outlook), surveyed on {jour}.',
      defaut: 'Orion · audience simulation. Published figures come from their sources.',
    },
  },
  formats: {
    erreur: {
      formats: 'Formats could not be read',
      format: 'Format could not be read',
      titre: 'Give the format a title.',
      refuse: 'Format refused',
      archivage: 'Archiving refused',
      visuel: 'The visual could not be uploaded.',
      visuelLourd: 'The image is larger than 12 MB.',
      populations: 'Populations could not be read',
    },
    laComposition: 'the breakdown',
    etListe: '{debut} and {fin}',
    boucle: 'self-contained',
    feuilletonnantMin: 'serialised',
    episodes: '{nb} episodes',
    adapteDe: 'adapted from: {pays}',
    premiereLe: 'first broadcast on {jour}',
    sousTitre: 'Audience simulation for TV, film and streaming: a format’s ladder of proof',
    leBrief: 'The format brief',
    creePar: 'Created by {nom}',
    unNouveau: 'A new format',
    champ: {
      titre: 'Title',
      titrePlaceholder: 'Even a working title',
      logline: 'Logline: the programme in one or two sentences',
      promesse: 'The promise to the viewer',
      genre: 'Genre',
      genrePlaceholder: 'entertainment, game show, drama, documentary…',
      diffuseur: 'Target broadcaster',
      sansDestination: 'No destination yet',
      case: 'Slot',
      casePlaceholder: 'Saturday prime time',
      cibles: 'Targets',
      ecriture: 'Structure',
      nonDecidee: 'Undecided',
      bouclee: 'Self-contained',
      feuilletonnante: 'Serialised',
      episodes: 'Episodes',
      objectif: 'Audience target',
      objectifPlaceholder: 'hold a 20% share of individuals 4+',
      premiere: 'First broadcast',
      paysOrigine: 'Foreign format: country of origin',
      visuel: 'The format visual',
      visuelAjouter: 'Add an image',
      visuelRemplacer: 'Replace the image',
      visuelRetirer: 'Remove',
    },
    enregistrerBrief: 'Save the brief',
    creer: 'Create the format',
    brief: 'The brief',
    laPromesse: 'The promise:',
    lObjectif: 'The target:',
    publicDuProgramme: 'The programme audience',
    publicPeutInterroger: 'This format’s tests can survey {nom} ({dimensions}).',
    escalier: 'The ladder of proof',
    panelConseille: 'Suggested panel: {noms}',
    tester: 'Test',
    unePreuve: 'Proof, before you shoot',
    deposer: 'Submit a format',
    soireesEtRegistre: 'Evenings and the register',
  },
  soirees: {
    titre: 'Evenings & register',
    sousTitre: 'The simulated evening, projected before broadcast, then checked against the published ratings',
    erreur: {
      registre: 'Register could not be read',
      grille: 'Schedule could not be read',
      soiree: 'Evening refused',
      grilleRefusee: 'Schedule refused',
      releve: 'Fetch refused',
      projection: 'Projection refused',
      enveloppe: 'Envelope could not be read',
      saisie: 'Entry refused',
      preuve: 'Proof unavailable',
      calibration: 'Calibration could not be read',
    },
    statutGrille: {
      en_cours: 'fetching',
      propose: 'to review',
      valide: 'approved',
      echec: 'fetch failed',
    },
    essai: 'Dry run',
    backtestAveugle: 'Blind backtest',
    projection: 'Projection',
    diffusionLe: 'Broadcast on {jour}',
    projeteeLe: 'projected on {moment}',
    leRegistre: 'The register',
    enveloppeAImprimer: 'Printable envelope',
    soireeSimulee: 'The simulated evening',
    projeteEtEuLieu: 'What was projected, and what happened',
    calibrationAppliquee: 'Calibration v{version} applied to the projection.',
    preuve: {
      titre: 'The proof',
      empreinte: 'SHA-256 fingerprint of the canonical content:',
      recalculee: 'Just recomputed: the content has not changed.',
      neCorrespondPlus: 'The fingerprint no longer matches the content.',
      temoins: 'The witnesses (OpenTimestamps, then anchored in Bitcoin):',
      telecharger: 'Download the .ots proof',
      telechargerContenu: 'Download the sealed .json content',
      retirerPublic: 'Remove from the public register',
      rendrePublique: 'Make public',
    },
    audiencePubliee: 'Published ratings',
    relever: 'Fetch',
    pasEncoreDiffusee: 'It has not aired yet.',
    placeholderSource: 'source',
    saisir: 'Enter',
    onglet: {
      registre: 'The register',
      soirees: 'Evenings',
      calibration: 'Calibration',
    },
    registre: {
      enregistrees: 'projections recorded',
      confrontees: 'pre-broadcast projections checked against reality',
      pts: '{v} pts',
      erreurMoyenne: 'average error (individuals 4+)',
      erreurBrute: ', {v} pts raw',
      dansLaFourchette: 'within the projected range',
      tableau: 'The scoreboard',
      calibrationActive: 'Active calibration: v{version}',
      aucune: 'No envelopes yet.',
      diffusion: 'Broadcast',
      projetee4: 'Projected (4+)',
      temoins: 'Witnesses',
      essai: 'dry run',
      backtest: 'backtest',
    },
    uneSoiree: 'An evening',
    releverGrilleEtPublic: 'Fetch the schedule and the reference audience',
    releverSoiree: 'Fetch the evening',
    saisirGrille: 'Enter the schedule',
    relevezUneGrille: 'Fetch an evening’s schedule.',
    laGrilleSeReleve: 'The schedule is being fetched.',
    projeterAudience: 'Project its audience',
    ajouterChaine: 'Add a channel',
    publicDeReference: 'The reference audience: viewers watching TV in this slot',
    sources: 'Sources',
    validerGrille: 'Approve the schedule',
    audiencesDeLaSoiree: 'The evening’s ratings',
    validerLignes: 'Approve the {nb} sourced rows',
    releverAudiences: 'Fetch the evening’s ratings',
    releveEchoue: 'The fetch failed: {raison}',
    calibration: {
      titre: 'A separate, versioned layer that learns only from the past',
      texte1: 'The twins never see the target result. Calibration corrects the reading, not the panel: target by target, it learns from every programme of the evenings already checked against their published ratings, from what the panel read and from what the channel usually achieves.',
      texte2: 'Its effect is measured by cross-validation (each evening corrected by what was learnt without it), and a version only applies once activated by hand.',
      confrontes: '{programmes} programmes checked, across {soirees} evenings | {programmes} programmes checked, across {soirees} evening | {programmes} programmes checked, across {soirees} evenings',
      erreur: 'error {avant} pts raw → {apres} pts corrected',
      apprendre: 'Learn a new version',
      commeReference: 'Engine reference, for accounts without a calibration',
      reference: 'engine reference',
      famille: { habitudes: 'evenings with channel habits', sans_habitudes: 'evenings without channel habits' },
      parProgramme: 'Programme by programme',
      soiree: 'Evening',
      panel: 'Panel',
      habitude: 'Channel’s usual share',
      corrige: 'Corrected',
      reel: 'Actual',
      version: 'Version {version}',
      activeDepuis: 'active since {moment}',
      appriseSurProgrammes: 'learnt from {programmes} programmes across {soirees} evenings on {moment} | learnt from {programmes} programmes across {soirees} evening on {moment} | learnt from {programmes} programmes across {soirees} evenings on {moment}',
      appriseSur: 'learnt from {soirees} evenings on {moment} | learnt from {soirees} evening on {moment} | learnt from {soirees} evenings on {moment}',
      erreurVersion: 'error {avant} → {apres} pts',
      activer: 'Activate',
      decalage: '{cible}: {points} at 20% ({nb})',
      modele: '{cible}: {description} ({nb} programmes)',
      exemple: '{cible}: a programme read at 20% is corrected to {grande} on a big channel, {petite} on a small one{genre} ({nb} programmes)',
      puisSelonGenre: ', then by its genre',
      corrigeeDuGenre: ', adjusted for the programme’s genre',
      partHabituelle: 'the channel’s usual share{genre}',
      partDeLHabitude: 'starts from the channel’s usual share, which the panel shifts{genre}',
      lectureRamenee: 'the panel’s reading, scaled to all of television{genre}',
      aucuneVersion: 'No versions yet.',
    },
  },
  diffuseurs: {
    titre: 'Broadcasters',
    sousTitre: 'Who watches each channel and platform, how its audience share moves, what its audience talks about',
    erreur: {
      sorties: 'Releases could not be read',
      createurs: 'Creators could not be read',
      tendances: 'Trends could not be read',
      soirees: 'Evenings could not be read',
      programme: 'Schedule could not be read',
      carte: 'Profile could not be read',
      diffuseurs: 'Broadcasters could not be read',
      recherche: 'Search failed',
    },
    onglet: {
      ensemble: 'Overview',
      programme: 'Schedule',
      soirees: 'Evenings',
      sorties: 'Releases',
      tendances: 'Trending',
      createurs: 'Rising creators',
    },
    saisonEpisode: 'season {saison}, episode {episode}',
    saison: 'season {saison}',
    points: '{v} pts',
    netflix: {
      series: 'Most-watched series',
      films: 'Most-watched films',
      horsAnglais: 'Most-watched non-English titles',
      titre: 'What the world watched on Netflix · {periode}',
      rapport: 'Netflix’s report',
      placeholder: 'A title, across every report since 2023: Lupin, Love Is Blind, Squid Game…',
      chercher: 'Search',
      periodeCol: 'Period',
      titreCol: 'Title',
      rang: 'Rank',
      vuesCol: 'Views',
      heures: 'Hours',
      sortie: 'Release',
      serie: 'series',
      film: 'film',
      aucun: 'No title by that name in the reports.',
    },
    periode: '{debut} to {fin}',
    semestre1: 'H1 {annee}',
    semestre2: 'H2 {annee}',
    lesChaines: 'Channels',
    lesPlateformes: 'Platforms',
    plateforme: 'Platform',
    chaine: 'Channel',
    pdaEn: '{pda} audience share in {mois}',
    ecartSur: '{ecart} vs {mois}',
    tous: 'All broadcasters',
    carteAImprimer: 'Printable profile',
    laVeille: 'Previous day',
    leLendemain: 'Next day',
    aucunProgramme: 'No programmes recorded that day.',
    archive: '{nom}’s schedule is archived from {debut} to {fin}.',
    soiree: 'Evening',
    premierePartie: 'Prime time',
    moyenne: '{pda} on average over {soirees} measured evenings | {pda} on average over {soirees} measured evening | {pda} on average over {soirees} measured evenings',
    moisDAvant: 'Previous month',
    moisDApres: 'Next month',
    aucuneSoiree: 'No evenings recorded this month.',
    aucuneSortie: 'No releases recorded for this month.',
    relevees: 'Recorded:',
    laSource: 'Source',
    tendancesChaqueMatin: 'Trends are fetched every morning.',
    sujetsDuJour: 'Today’s topics',
    releve: {
      tiktok: 'Trending hashtags over seven days',
      x: 'Today’s trends',
      fils: 'Today’s most-followed threads',
    },
    vues: '{v} views',
    messages: '{v} posts',
    publications: '{v} posts',
    heuresSur24: '{h}h out of 24',
    septDerniersJours: 'over the last seven days, up to {jour}',
    classementSeForme: 'The ranking is taking shape: it is fetched every morning.',
    nouveau: 'New',
    joursSur7: '{n} days out of 7 | {n} day out of 7 | {n} days out of 7',
    abonnes: '{v} followers',
    progression: '{v} in {jours}d',
    voirLesPremiers: 'See the top {nb}',
    personas: {
      titre: 'Its audience’s personas',
      origine: '{nom}’s audience',
      q1: 'What do you come here for?',
      q2: 'Which programme did you miss this year?',
      q3: 'What would make you go elsewhere?',
    },
    pasDePublics: 'No audiences described for this broadcaster yet.',
    pdaMoisParMois: 'Its audience share, month by month (Médiamat, {cible})',
    horsMediamat: 'Platforms are not in Médiamat.',
    pasAssezDeMois: 'Not enough months published yet.',
    top10Semaine: 'The published Top 10, week of {semaine}',
    classementAdn: 'The most popular series on ADN, as of {jour}',
    ceQuiBouge: 'What’s moving over these three weeks',
    mouvement: {
      apparu: 'emerging',
      monte: 'rising',
      faiblit: 'fading',
    },
    joursDAffilee: ', {nb} days running',
    aucunFormat: 'No format targets this broadcaster yet.',
    compareA: ', compared with {mois}',
    surLeMoisDAvant: ', on the previous month',
    classementPublie: 'Published ranking',
    horsMediamatCourt: 'outside Médiamat',
    formatsTestes: '{n} formats tested | {n} format tested | {n} formats tested',
  },
  pays: {
    titre: 'Export markets',
    sousTitre: 'Each country read through its own formats: how they performed there, and how much its population wants to watch them',
    erreur: {
      liste: 'Countries could not be read',
      pays: 'Country could not be read',
      etalonnage: 'Benchmarking refused',
    },
    laReference: 'The reference',
    lesPaysDeLExport: 'Export markets',
    sansEtalonValide: 'No approved benchmark',
    etalonsValides: '{nb} benchmark formats approved out of {total} | {nb} benchmark format approved out of {total} | {nb} benchmark formats approved out of {total}',
    etalonneLe: 'benchmarked on {moment}',
    tousLesPays: 'All countries',
    releverEtalons: 'Fetch the benchmark formats',
    etalonnerCePays: 'Benchmark this country',
    dernierReleveEchoue: 'The last fetch failed: {raison}',
    ceQueLaPopulationDonne: 'How the population of {pays} rates the benchmark formats',
    droitePda: 'A format that {envie} of this panel would want to watch launches here at around {valeur} audience share;',
    dixPointsPda: 'ten more points of appetite are worth {ecart} points of audience share. | ten more points of appetite are worth {ecart} point of audience share. | ten more points of appetite are worth {ecart} points of audience share.',
    droiteTelespectateurs: 'A format that {envie} of this panel would want to watch launches here at around {valeur} viewers;',
    dixPointsDePlus: 'ten more points of appetite add {valeur} viewers.',
    dixPointsDeMoins: 'ten more points of appetite cost {valeur} viewers.',
    voirTest: 'See the benchmarking test',
    etalonsDansCePays: 'Benchmark formats in this country',
    statut: {
      propose: 'to approve',
      valide: 'approved',
      rejete: 'discarded',
    },
    pasEncoreReleve: 'not fetched yet',
    placeholderChaine: 'channel',
    placeholderAnnee: 'year',
    enregistrerEtValider: 'Save and approve',
    annulerMin: 'cancel',
    saisons: '{n} seasons | {n} season | {n} seasons',
    jamaisDiffuse: 'Never aired in this country.',
    corriger: 'Edit',
    lesEtalonnages: 'Benchmark runs',
    nFormats: '{nb} formats',
    nEtalonsValides: '{n} benchmarks approved | {n} benchmark approved | {n} benchmarks approved',
    etalonneLeMaj: 'Benchmarked on {moment}',
    aEtalonner: 'To benchmark',
    masquerSansEtalon: 'Hide countries without a benchmark',
    voirSansEtalon: 'See the {nb} countries without a benchmark',
  },
  weekly: {
    titre: 'The brief',
    sousTitre: 'Audiences opening up, creators on the rise, genres reaching saturation',
    type: {
      espace_blanc: 'White space',
      opportunite: 'Opportunity',
      emergence: 'Emergence',
      extension: 'Extension',
    },
    erreur: {
      brief: 'The weekly could not be read',
      lecture: 'Reading refused',
    },
    terrain: 'What the field is saying this week',
    luLe: 'Read on {moment}',
    lectureEnCours: 'Reading in progress',
    relire: 'Read again now',
    lire: 'Read the week',
    echec: 'The reading failed.',
    laSemaineSeLit: 'The week is being read.',
    pourquoiMaintenant: 'Why now:',
    aTrancher: 'To decide: “{question}”',
    enFaireUnFormat: 'Make it a format',
    pasEncore: 'No brief yet.',
  },
  programme90: {
    titre: '90-day programme',
    sousTitre: '{nom} · D0 → D+90',
    dashboard: 'Dashboard',
    jour: 'D{n}',
    auditInitial: 'Initial audit',
    baseline: '4R baseline',
    aucuneCampagne: 'no campaign launched',
    reAudit: 'Re-audit',
    scoreImplantationMin: 'implantation score',
    reconstruction: 'Rebuilding the programme (audits + campaigns)…',
    demarre: 'The programme starts with the first audit - launch one from the Audits screen.',
    evolution: '4R trend - measured to date',
    chargementHistorique: 'Loading the history…',
    deuxAnalyses: 'At least 2 analyses are needed to plot a trajectory.',
    historiqueSeRemplit: 'The history fills up with each “Run the full analysis”.',
    scoreImplantation: 'Implantation score',
    mesureAuReAudit: 'measured at the D+90 re-audit',
    reAuditDu: 're-audit of {date}',
    definition: '= brand score recalculated on the new cluster after implantation.',
    scoreActuel: 'Current brand score',
    analysesHistorisees: 'Analyses on record',
  },
}
